import {
  tokenUrl,
  quesParentUrl,
  quesChildUrl,
  submitUrl,
  getQuestionRequestParams,

} from "./url";
import { header } from "./header";
import { appConstants } from "../utils/constants";

export const tokenConfig = {
  method: "get",
  url: tokenUrl,
  headers: {},
};



export const parentQuesConfig = (
  type,
  ratingId,
  currentLanguageCode,
  conceptCode
) => {
  return {
    method: "get",
    url: `${quesParentUrl}/${type}/${ratingId}/${
      currentLanguageCode === appConstants.en
        ? appConstants.eng
        : appConstants.arb
    }/${conceptCode}`,
    headers: header,
  };
};

export const childQuesConfig = (parentId, currentLanguageCode) => {
  return {
    method: "get",
    url: `${quesChildUrl}/${parentId}/${
      currentLanguageCode === appConstants.en
        ? appConstants.eng
        : appConstants.arb
    }`,
    headers: header,
  };
};

export const questionMasterConfig = (storeCode, conceptCode, categoryCode) => {
  return {
    method: "get",
    url: `${getQuestionRequestParams}/${storeCode}/concept-code/${conceptCode}/category-code/${categoryCode}`,
    headers: header,
  };
};

export const npsSubmitConfig = (submitFormData) => {
  return {
    method: "post",
    url: submitUrl,
    headers: header,
    data: submitFormData,
  };
};
